import User from '../../types/User';
import { ProgramEvaluationSchema } from '../../types/Evaluation';

export const SET_USER = 'user/SET_USER';
export const UPDATE_PREFERENCES = 'user/UPDATE_PREFERENCES';
export const SET_PROGRAM_CBTN_USERNAME = 'user/SET_PROGRAM_CBTN_USERNAME';
export const SET_PROGRAM_EVALUATION_DATA_SCHEMA = 'user/SET_PROGRAM_EVALUATION_DATA_SCHEMA';

export function setUserAction(user:User) {
  return {
    type: SET_USER,
    user,
  };
}

export function setProgramCbtnUsername(programCbtnUsername: string | null) {
  return {
    type: SET_PROGRAM_CBTN_USERNAME,
    programCbtnUsername,
  };
}

export function setProgramEvaluationDataSchemaAction(programEvaluationDataSchema: ProgramEvaluationSchema) {
  return {
    type: SET_PROGRAM_EVALUATION_DATA_SCHEMA,
    programEvaluationDataSchema,
  };
}

export function setAndUpdateUserPreferencesAction(preferences:any) {
  return {
    type: UPDATE_PREFERENCES,
    preferences,
  };
}

